<h3>
  <a [routerLink]="menu.slug">
    {{ menu.name }}
  </a>
</h3>

<ul *ngIf="hasChildren">
  <li *ngFor="let item of children">
    <a [routerLink]="item.slug" (click)="onClick()">
        {{ item.name }}
    </a>
  </li>
</ul>
